import type { Filter, FilterDataRange } from '@/app/common/filters/core/filtersTypes.ts';
import { FilterRangePill } from '@/app/common/filters/types/range/FilterRangePill.ts';
import type { FilterTypeBehaviour } from '@/app/common/filters/types/filterTypeDefinition.ts';
import { isRangeFilterSelected } from '@/app/common/filters/core/filterUtils.ts';

const dataOf = (filter: Filter) => filter.data as FilterDataRange;

export const rangeType: FilterTypeBehaviour = {
  pillLabels: FilterRangePill,
  serialise: (filter) => {
    const data = dataOf(filter);

    return isRangeFilterSelected(filter) ? [data.value.min, data.value.max].join(',') : undefined;
  },
  isSelected: isRangeFilterSelected,
  resetValue: (filter) => ({
    ...filter,
    data: { ...dataOf(filter), value: { min: dataOf(filter).default.min, max: dataOf(filter).default.max } },
  }),
};
